import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconChevronDownBold(_a) {
    var colorVariant = _a.colorVariant, size = _a.size;
    var theme = useContext(ThemeContext);
    var color = setColor(theme, colorVariant, 'secondary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", { width: renderSize, height: renderSize, viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("path", { d: "M22.2222 25L8.33331 38.8889L50 80.5556L91.6667 38.8889L77.7778 25L50 52.7778L22.2222 25Z", fill: color })));
}
//# sourceMappingURL=icon.chevron-down-bold.component.js.map